export enum DialogCloseEnum {
  Confirm = 'CONFIRM',
  Logout = 'LOGOUT',
}
